const localStorageKeys = { token: "token" };

export default localStorageKeys;
